import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { SortField } from "@src/store/helpers";
import { PagedEvents } from "@src/store/pricing/queryEventsSlice";

export interface IQueryPoEventParams {
	EventFromDate?: string | null;
	EventToDate?: string | null;
	CategoryId?: number | null;
	EventHeadlinerId?: number | null;
	VenueId?: number | null;
	EventId?: number | null;
	SearchString?: string | null;
	OrderByColumn?: Array<SortField> | null;
	StartIndex?: number | null;
	Limit?: number | null;
	IncludeParking?: boolean | null;
	ForceRefresh?: boolean | null;
	ExcludeEventsWithTickets?: boolean | null;
	Tags?: string | null;
}

const initialState: PagedEvents = {
	itemCount: 0,
	Events: [],
};

export const { thunk: queryNewPoEvents, slice: newPoEventsSlice } = getThunkAndSlice<IQueryPoEventParams, PagedEvents>({
	name: "newPoEvents",
	initialState,
	path: "/api/Purchasing/QueryEvents",
	method: "post",
});

export const { update: updateNewPoEvents, reset: resetNewPoEvents } = newPoEventsSlice.actions;
